import React,{useState,useEffect} from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// components
import Homepage from './pages/Home/Homepage.jsx'
import Navbar from './components/Navbar/Navbar'
import Web3 from "web3";

import { LoadingModal, MessageModal } from './components/Modal/Modal';

const App = () => {
    const web3 = new Web3(Web3.givenProvider);
    const [metamaskAddress,setMetamaskAddress] = useState("");

    const [open, setOpen] = React.useState(false)
    const [openMessage, setOpenMessage] = useState(false)
    const [messageData, setMessageData] = useState('Some Error Occurred...')
    // const [chainId,setChainId] = useState(1);
    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    const showMessage = () => setOpenMessage(true)
    const closeMessage = () => setOpenMessage(false)

    
    
    const connectMetamask = async () => {
        handleOpen()
        if(window.ethereum) {
            const accounts = await window.ethereum.request({
                method: 'eth_requestAccounts',
            })
            const chainId = await web3.eth.getChainId();

            if(chainId !== 1) {
                handleClose()
                showMessage()
                setMessageData("Please connect to Ethereum Mainnet")
                return;
            }
            setMetamaskAddress(accounts[0]);
            localStorage.setItem("metamask_wallet",accounts[0]);
            handleClose()
        }
        else {
            handleClose()
            showMessage()
            setMessageData('Please Install Metamask First')
        }
    }
    if (window.ethereum) {
        window.ethereum.on('accountsChanged', function (accounts) {
            // console.log(accounts[0])
            setMetamaskAddress(accounts[0])
            localStorage.setItem("metamask_wallet",accounts[0]);
            
        })
    }
    useEffect(() => {
        if(localStorage.getItem('metamask_wallet')) {
            setMetamaskAddress(localStorage.getItem('metamask_wallet'))
        }
    },[metamaskAddress]);

    useEffect(async () => {
        try {
            await window.ethereum.request({
              method: "wallet_switchEthereumChain",
              params: [{ chainId: "0x1" }], // chainId must be in hexadecimal numbers
            });
          } catch (err) {
            console.log(err);
          }
    },[]);
    
    return (
        <div className='App'>
            <BrowserRouter>
                <Navbar 
                metamaskAddress={metamaskAddress}
                connectWallet={connectMetamask}/>

            <LoadingModal
                handleOpen={handleOpen}
                handleClose={handleClose}
                setOpen={setOpen}
                open={open}
            />

            <MessageModal
                message={messageData}
                handleOpen={showMessage}
                handleClose={closeMessage}
                setOpen={setOpenMessage}
                open={openMessage}
            />

                <Routes>
                    <Route exact path='/' element={
                    <Homepage connectWallet={connectMetamask} metamaskAddress={metamaskAddress}/>} />
                </Routes>
            </BrowserRouter>
        </div>
    )
}

export default App
